import { render, staticRenderFns } from "./PatientManagement.vue?vue&type=template&id=f128d5e4&scoped=true"
import script from "./PatientManagement.vue?vue&type=script&lang=js"
export * from "./PatientManagement.vue?vue&type=script&lang=js"
import style0 from "./PatientManagement.vue?vue&type=style&index=0&id=f128d5e4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f128d5e4",
  null
  
)

export default component.exports